module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div id="' +
((__t = (id)) == null ? '' : __t) +
'" class="DescartesModal modal fade" role="dialog">\n    <div class="modal-dialog">\n        <!-- Modal content-->\n        <div class="modal-content">\n            <div class="modal-body">\n                <span class="DescartesUIText">' +
((__t = (message)) == null ? '' : __t) +
'<span>\n                <div class="progress">\n                    <div class="progress-bar ' +
((__t = (progressBarCss)) == null ? '' : __t) +
' progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%">\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/DMap/UI/bootstrap4/templates/WaitingDialog.ejs
// module id = 318
// module chunks = 0